<!-- by 7527189 2 0 -->
<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="关键词" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品名称、防伪名称、UDI名称" v-model="queryParam.dataParam"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!-- <JDate v-model:value="queryParam.createTime" /> -->
                  <a-range-picker v-model="noQueryParam.createTime" format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']"
                                  @change="onDateChange" @ok="onDateOk" />
                </a-form-item>
              </a-col>
              <!-- <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择状态" v-model="queryParam.status">
                    <a-select-option value="1">待入库</a-select-option>
                    <a-select-option value="2">已入库</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="批号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入批次号" v-model="queryParam.batchNumber"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button type="primary" @click="searchQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>

          <a-button v-if="btnEnableList.indexOf(1) > -1" @click="handleAdd" type="primary" icon="plus">新增</a-button>
          <!-- <a-button @click="handleImportXls()" type="primary" icon="import">导入</a-button>
          <a-button type="primary" icon="download" @click="handleExportXls('商品信息')">导出</a-button> -->
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1" v-if="btnEnableList.indexOf(1) > -1" @click="batchDel"><a-icon
                type="delete" />删除</a-menu-item>
              <a-menu-item key="2" v-if="btnEnableList.indexOf(1) > -1" @click="batchSetStatus(true)"><a-icon
                type="check-square" />启用</a-menu-item>
              <a-menu-item key="3" v-if="btnEnableList.indexOf(1) > -1" @click="batchSetStatus(false)"><a-icon
                type="close-square" />禁用</a-menu-item>
              <a-menu-item key="4" v-if="btnEnableList.indexOf(1) > -1" @click="batchEdit()"><a-icon
                type="edit" />批量编辑</a-menu-item>
              <a-menu-item key="5" v-if="btnEnableList.indexOf(1) > -1" @click="batchSetMaterialCurrentStock()"><a-icon
                type="stock" />修正库存</a-menu-item>
            </a-menu>
            <!-- <a-button>
              批量操作 <a-icon type="down" />
            </a-button> -->
          </a-dropdown>
          <!-- <a-upload v-model:file-list="fileList" :before-upload="beforeUpload" :maxCount="1" :disabled="isUpload" accept=".txt" name="file" action="/jshERP-boot/acquisition/acquisitionAdd" :headers="headers" @change="handleChange">
            <a-button icon="upload">
              <upload-outlined></upload-outlined>
              上传文件
            </a-button>
          </a-upload> -->
          <!-- <a-button @click="uploadfile">
            新增
          </a-button> -->
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="picitable" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
                   :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"
                   :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, columnWidth: '2%' }"
                   @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
<!--              <a v-if="record.status != 2 && record.status != 0 && record.status != -1 && record.status != -2" @click="Warehousing(record)">入库</a>-->
<!--              <a v-if="record.status == -1" @click="ModifyCollectData(record.uuid)">重新采集</a>-->
<!--              <a v-if="record.status == -2" @click="Warehousing(record)">重新入库</a>-->
              <a @click="details(record)">明细</a>
            </span>
            <!-- <span slot="nameTitle">
              名称
              <a-tooltip title="消费者进行防伪查询时展示的该产品的名称">
                <a-icon type="question-circle" />
              </a-tooltip>
            </span>
            <span slot="UDITitle">
              UDI名称
              <a-tooltip title="申报DI时的产品名称">
                <a-icon type="question-circle" />
              </a-tooltip>
            </span>
            <span slot="pTitle">
              产品名称
              <a-tooltip title="企业内部进行产品区分的名称">
                <a-icon type="question-circle" />
              </a-tooltip>
            </span> -->
            <span slot="createTime" slot-scope="text, record">
              <span>{{ timestampToTime(record.createTime) }}</span>
            </span>

            <template slot="status" slot-scope="status">
              <a-tag v-if="status == -1" color="red">采集异常</a-tag>
              <a-tag v-if="status == -2" color="red">入库异常</a-tag>
              <a-tag v-if="status == 0" color="orange">上传中</a-tag>
              <a-tag v-if="status == 1" color="blue">待入库</a-tag>
              <a-tag v-if="status == 2" color="green">已入库</a-tag>
              <a-tag v-if="status == 3" color="orange">入库中</a-tag>
            </template>

            <template slot="createTime" slot-scope="createTime">
              <span>{{ timestampToTime(createTime) }}</span>
            </template>

            <template slot="packSpec" slot-scope="text, record">
              <div v-if="record.packSpec && record.packSpec.split(',')">
                <div v-for="it in record.packSpec.split(',' || '，')">{{ it.substring(9) ? it : '' }}</div>
              </div>
            </template>
            <!-- <template slot="details" slot-scope="text, record">
              <div v-for="(it,idx) in record.details">
                <span>{{it.packType}}级包装<span>{{it.counts}}个</span></span>
                <a-divider v-if="record.details!=1&&idx!=record.details.length-1" />
              </div>
            </template> -->

            <!-- <span slot="fileName" slot-scope="text, record">
              <a @click="details(record)">{{record.fileName}}</a>
            </span>

             <template slot="customRenderEnabled" slot-scope="enabled">
              <a-tag v-if="enabled" color="green">启用</a-tag>
              <a-tag v-if="!enabled" color="orange">禁用</a-tag>
            </template> -->
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <import-file-modal ref="modalImportForm" @ok="modalFormOk"></import-file-modal>
        <Warehouse @fatherMethod="fatherMethod" ref="UploadModel" @ok="UploadModelOk"></Warehouse>
        <detail-model  ref="detailModel" ></detail-model>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import Warehouse from './modules/warehouse'
import detailModel from './modules/detailModel'
import ImportFileModal from '@/components/tools/ImportFileModal'
import { queryMaterialCategoryTreeList,collectModify } from '@/api/api'
import { postAction, getFileAccessHttpUrl } from '@/api/manage'
import { getMpListShort } from '@/utils/util'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'MaterialList',
  mixins: [JeecgListMixin],
  components: {
    Warehouse,
    detailModel,
    // MaterialModal,
    ImportFileModal,
    // BatchSetInfoModal,
    JEllipsis,
    JDate,
  },
  data () {
    return {
      List: [],
      isUpload: false,
      headers: {
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN),
        tenantId: this.$store.getters.tenantId,
      },
      categoryTree: [],
      mPropertyListShort: '',
      model: {},
      labelCol: {
        span: 3,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 查询条件
      queryParam: {
        dataParam: '',
        batchNumber: '',
      },
      noQueryParam:{
        createTime: '',
      },
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '50', '100', '200'],
      },
      // 实际表头
      columns: [],
      // 初始化设置的表头
      settingColumns: [
        'createBy',
        'di',
        'materialName',
        'udiName',
        'piName',
        'batchNumber',
        'standard',
        'packSpec',
        'fileName',
        'status',
        'createTime',
        'action',
        'details',
      ],
      // 默认的列
      defColumns: [
        { title: '批次', dataIndex: 'batchNumber', width: 40, ellipsis: true },
        { title: '产品名称', dataIndex: 'materialName', width: 40 },

        { title: '防伪名称', dataIndex: 'piName', width: 40 },
        { title: 'UDI名称', dataIndex: 'udiName', width: 40 },
        // { align: 'left', dataIndex: 'materialName', width: 50, slots: { title: 'nameTitle' } },
        // { align: 'left', dataIndex: 'piName', width: 50, slots: { title: 'pTitle' } },
        // { align: 'left', dataIndex: 'udiName', width: 50, slots: { title: 'UDITitle' } },
        { title: '规格', dataIndex: 'standard', width: 100 },
        { title: '包装规格', dataIndex: 'packSpec', width: 100},
        { title: '采集日期', dataIndex: 'createTime', width: 60, scopedSlots: { customRender: 'createTime' } },

        { title: 'DI信息', dataIndex: 'di', width: 40 },
        // { title: '形式', dataIndex: 'standard', width: 120 },
        // { title: '上传文件', dataIndex: 'fileName', width: 40, scopedSlots: { customRender: 'fileName' } },
        // { title: '产品数量', dataIndex: 'materialOther', width: 40, ellipsis: true },
        { title: '状态', dataIndex: 'status', align: 'center', width: 40, scopedSlots: { customRender: 'status' } },
        // {
        //   title: '操作时间',
        //   dataIndex: 'createTime',
        //   align: 'center',
        //   width: 40,
        //   scopedSlots: { customRender: 'createTime' },
        // },
        // {
        //   title: '包装详情',
        //   dataIndex: 'details',
        //   align: 'center',
        //   width: 40,
        //   // scopedSlots: { customRender: 'details' },
        // },
        // {
        //   title: '明细',
        //   dataIndex: 'unit',
        //   width: 100,
        //   ellipsis: true,
        //   customRender: function (t, r, index) {
        //     if (r) {
        //       let name = t ? t : r.unitName
        //       if (r.sku) {
        //         return name + '[SKU]'
        //       } else {
        //         return name
        //       }
        //     }
        //   },
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 30,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/dataAcquisitionAccumulatedV2/batchNumberList',
        delete: '/material/delete',
        deleteBatch: '/material/deleteBatch',
        importExcelUrl: '/material/importExcel',
        exportXlsUrl: '/material/exportExcel',
        batchSetStatusUrl: '/material/batchSetStatus',
        batchSetMaterialCurrentStockUrl: '/material/batchSetMaterialCurrentStock',
      },
    }
  },
  created () {
    this.initColumnsSetting()
    // this.loadTreeData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    },
  },
  methods: {
    // 明细
    async details (record) {
      this.$refs.detailModel.show(record)
      this.$refs.detailModel.title = '批次采集明细'
    },

    onDateOk () { },
    onDateChange: function (value, dateString) {
      this.queryParam.beginTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    fatherMethod () {
      this.loadData(1)
    },
    Warehousing (record) {
      this.uploadfile(record)
    },
    ModifyCollectData(record){
      let that = this
      collectModify({id: record}).then((res)=>{
        if(res && res.code===200) {
          this.$message.info('重新采集成功！')
          that.loadData()
        } else {
          console.log(res.data)
          this.$message.warning('重新采集失败！'+res.msg)
        }
      });
    },
    uploadfile: function (e) {
      // this.$refs.UploadModel.edit()
      this.$refs.UploadModel.show(e)
      this.$refs.UploadModel.title = '仓库'
    },
    // uploadfile: function (e) {
    //   // this.$refs.UploadModel.edit()
    //   this.$refs.UploadModel.show(e)
    //   this.$refs.UploadModel.title = '上传文件'
    // },
    UploadModelOk () { },
    //加载初始化列
    initColumnsSetting () {
      let columnsStr = Vue.ls.get('picitable')
      if (columnsStr && columnsStr.indexOf(',') > -1) {
        this.settingColumns = columnsStr.split(',')
      }
      this.columns = this.defColumns.filter((item) => {
        if (this.settingColumns.includes(item.dataIndex)) {
          return true
        }
        return false
      })
      console.log(this.columns, ' this.columns')
    },

    loadTreeData () {
      let that = this
      let params = {}
      params.id = ''
      queryMaterialCategoryTreeList(params).then((res) => {
        if (res) {
          that.categoryTree = []
          for (let i = 0; i < res.length; i++) {
            let temp = res[i]
            that.categoryTree.push(temp)
          }
        }
      })
    },
    batchSetMaterialCurrentStock () {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
      } else {
        let ids = ''
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        let that = this
        this.$confirm('是否操作选中数据?', '确认操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          that.loading = true
            postAction(that.url.batchSetMaterialCurrentStockUrl, { ids: ids })
              .then((res) => {
                if (res.code === 200) {
                  that.$message.info('修正库存成功！')
                  that.loadData()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.data.message)
                }
              })
              .finally(() => {
                that.loading = false
              })
        }).catch(() => {});
      }
    },
    batchEdit () {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
      } else {
        let ids = ''
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        this.$refs.batchSetInfoModalForm.edit(ids)
        this.$refs.batchSetInfoModalForm.title = '批量编辑'
      }
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true
      }
    },
    getImgUrl (imgName) {
      if (imgName && imgName.split(',')) {
        return getFileAccessHttpUrl('systemConfig/static/' + imgName.split(',')[0])
      } else {
        return ''
      }
    },
    handleImportXls () {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = '/doc/goods_template.xls'
      let templateName = '商品Excel模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '商品导入'
    },
    searchReset () {
      this.queryParam = {
        mpList: getMpListShort(Vue.ls.get('materialPropertyList')), //扩展属性
      }
      this.loadData(1)
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
